import type { LearningGrainEntity } from '@/core/infrastructure/schemas/dashboard/ClassroomResultsSchema'

/**
 * Classe représentant un grain d'apprentissage
 */
export class LearningGrain {
  readonly learningGrainId: number
  readonly learningGrainTitle: string
  readonly learningGrainOrder: number
  readonly postQuizVersionNumber: number | null
  readonly postQuizScoreScaled: number | null
  readonly postQuizScoreScaledHistory: number[]
  readonly postQuizCountAttempt: number
  readonly postQuizEvalRangeName: string | null

  constructor(data: LearningGrainEntity) {
    this.learningGrainId = data.learningGrainId
    this.learningGrainTitle = data.learningGrainTitle
    this.learningGrainOrder = data.learningGrainOrder
    this.postQuizVersionNumber = data.postQuizVersionNumber
    this.postQuizScoreScaled = data.postQuizScoreScaled
    this.postQuizScoreScaledHistory = data.postQuizScoreScaledHistory
    this.postQuizCountAttempt = data.postQuizCountAttempt
    this.postQuizEvalRangeName = data.postQuizEvalRangeName
  }

  /**
   * Vérifie si le grain a été complété
   */
  public isCompleted(): boolean {
    return this.postQuizVersionNumber !== null && this.postQuizScoreScaled !== null
  }

  /**
   * Obtient le score en pourcentage
   */
  public getScorePercent(): number | null {
    return this.postQuizScoreScaled ? Math.round(this.postQuizScoreScaled * 100) : null
  }

  /**
   * Crée une instance à partir de données brutes
   */
  public static create(data: unknown): LearningGrain {
    if (!data || typeof data !== 'object') {
      throw new Error('Invalid data for LearningGrain')
    }

    const grainData = data as LearningGrainEntity
    return new LearningGrain(grainData)
  }
}
